import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import {
  instalacionInitial,
  isLoading,
  loadDataInstalacion,
  loadListInstalacion,
} from '../context/Instalacion/InstalacionReducer';
import { Instalacion } from '../types/Instalacion';
import { findAll, get, remove, save, update } from '../services/Service';
import { logger } from '../utils/logger';

export const useInstalacion = () => {
  const BASE_URL = 'instalaciones';

  const { instalaciones, instalacionSelected, loading } = useSelector(
    (state: RootState) => state.instalacion
  );
  const dispatch = useDispatch();

  // Trae las instalaciones de la Empresa Gestora del usuario logueado
  // (mismo endpoint que ya usa el combo de Solicitud/Buscar) y aplica
  // un filtro por nombre en el cliente, ya que el endpoint no documenta
  // soporte de query params de búsqueda.
  const buscarInstalaciones = async (filtro?: { nombre?: string }) => {
    try {
      const response = await findAll(`${BASE_URL}/usuario-logueado`);
      const nombreFiltro = filtro?.nombre?.trim().toLowerCase();
      const data: Instalacion[] = response?.data || [];
      const resultado = nombreFiltro
        ? data.filter((instalacion) =>
            instalacion.nombre?.toLowerCase().includes(nombreFiltro)
          )
        : data;
      dispatch(loadListInstalacion(resultado));
    } catch (error) {
      logger.log(logger.safeError(error));
      dispatch(loadListInstalacion([]));
    }
  };

  const buscarInstalacion = async (id: string) => {
    try {
      const response = await get(BASE_URL, id);
      dispatch(loadDataInstalacion(response.data));
      return response.data;
    } catch (error) {
      logger.log(logger.safeError(error));
    }
  };

  const guardarInstalacion = async (instalacion: Instalacion) => {
    try {
      const response =
        instalacion.id === 0
          ? await save(BASE_URL, instalacion)
          : await update(BASE_URL, instalacion);
      dispatch(loadDataInstalacion(response.data));
      return response;
    } catch (error) {
      logger.log(logger.safeError(error));
      throw error;
    }
  };

  const eliminarInstalacion = async (id: string) => {
    try {
      return await remove(BASE_URL, id);
    } catch (error) {
      logger.log(logger.safeError(error));
      throw error;
    }
  };

  const handleInstalacionSelected = (instalacion: Instalacion) => {
    dispatch(loadDataInstalacion(instalacion));
  };

  const handleLoading = (load: boolean) => {
    dispatch(isLoading(load));
  };

  return {
    instalacionInitial,
    instalaciones,
    instalacionSelected,
    loading,
    buscarInstalaciones,
    buscarInstalacion,
    guardarInstalacion,
    eliminarInstalacion,
    handleInstalacionSelected,
    handleLoading,
  };
};
